import dayjs from "dayjs"

import type { EntityLock } from "@/graphql/codegen/graphql"

// AK-6388 — codegen exposes fragment-masked references (`$fragmentRefs` marker) on
// mutation/query response fields even though the resolver returns fully-populated
// scalars. This helper centralizes the coercion so it stays grep-able and can be
// swapped for `getFragmentData` if the app adopts fragment masking.
type MaskedEntityLock = { __typename: "EntityLock" } & Record<string, unknown>

export const toEntityLock = (masked: MaskedEntityLock | null | undefined): EntityLock | undefined =>
  masked ? (masked as unknown as EntityLock) : undefined

export const formatRelativeTime = (from: string): string => {
  const then = dayjs(from)
  if (!then.isValid()) return ""

  const diffSeconds = dayjs().diff(then, "second")
  if (diffSeconds < 45) return "just now"

  const diffMinutes = dayjs().diff(then, "minute")
  if (diffMinutes < 60) return `${diffMinutes} min ago`

  const diffHours = dayjs().diff(then, "hour")
  if (diffHours < 24) return `${diffHours} hr ago`

  const diffDays = dayjs().diff(then, "day")
  return `${diffDays} day${diffDays === 1 ? "" : "s"} ago`
}
